<template>
    <div style="color:white;font-size:12px;padding:5px 10px">
        {{stringvalue}}
    </div>
</template>
<script>
export default {
    props:["stringvalue"]
}
</script>